import React, { ReactNode, useEffect, useState } from 'react'
import { Modal } from 'src/components/Modal/Modal'
import { useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import { ApiErrorType, JobLevelType, ResponseType, ShipType } from 'src/types'
import { useTranslation } from 'react-i18next'
import { Button, InputField, MultiSelect } from 'src/components/UI'
import { useShipTypes } from '../../hooks'
import { toast } from 'react-toastify'
import { Post } from 'src/apis/apiWithType'
import { useJobLevels } from 'src/pages/basic-information/JobLevels/hooks'
import { Option } from 'react-multi-select-component'


interface ShipTypeMutateType {fa_name: string, en_name: string, types: string[] }

export const MutateShipType = ({ children, record, mode }: { children: ReactNode, record?: ShipType, mode: 'edit' | 'add' }) => {


    const { t } = useTranslation()

    const [open, setOpen] = useState<boolean>(false)

    const { refetch } = useShipTypes()

    const { data: jobLevelsData, isLoading: loadingOfJobLevels } = useJobLevels()

    const { register, formState: { errors }, reset, handleSubmit, setValue, getValues, watch } = useForm<ShipTypeMutateType>()

    const { mutate, isLoading } = useMutation<ResponseType<ShipType[]>, ApiErrorType, Partial<ShipTypeMutateType>>({
        mutationFn: (data) => record?.id ? Post(`/basic-information/ship-types/update/${record.id}`, { ...data, form: "update_form", types: data.types?.map(i => ({ job_level_id: i })) }) as any : Post('/basic-information/ship-types/store', { ...data, form: "store_form", types: data.types?.map(i => ({ job_level_id: i })) }),
        mutationKey: ['SingleShipType', record?.id ?? 'Create'],
        onSuccess: (suc) => {
            toast.success(t('AddedSuccessfully'))
            setOpen(false)
            refetch()
        },
        onError: (error) => {
            toast.error(error.data.message)
        }
    })



    useEffect(() => {
        if (record) {
            const { en_name, fa_name, levels } = record
            reset({ fa_name, en_name, types: levels?.map(i => i.id) ?? [] })
        }
    }, [record])

    useEffect(() => {
        if (mode == 'add')
            reset()
    }, [open])



    const handleMutateJobLevel = (data: Partial<JobLevelType>) => {
        mutate(data)

    }

    const jobLevels = jobLevelsData?.details?.data?.data ?? []

    console.log(watch())
    return (
        <>
            <div className='flex ' onClick={() => setOpen(true)}>
                {children}
            </div>

            <Modal open={open} setOpen={setOpen} title={record?.id ? t('EditShipType') : t('AddShipType')}>

                <form className='flex flex-col gap-4 min-w-64' onSubmit={handleSubmit(handleMutateJobLevel)}>
                    <InputField
                        label={t('faName')}
                        {...register('fa_name', { required: true })}
                    />

                    <InputField
                        label={t('enName')}
                        {...register('en_name', { required: true })}
                    />

                    <MultiSelect
                        isLoading={loadingOfJobLevels}
                        value={getValues('types')?.map(i => ({ label: jobLevels.find(f => f.id == i)?.fa_name ?? '', value: i })) ?? []}
                        labelledBy=''
                        options={jobLevels?.map(i => ({ label: i.fa_name, value: i.id }))}
                        onChange={(e: Option[]) => setValue('types', e.map(i => i.value))}
                    />



                    <Button loading={isLoading} keyTitle='save' type='submit' ></Button>



                </form>

            </Modal>
        </>
    )
}
